<section
  class="bg-gradient-to-b from-white to-gray-50 w-full py-16 px-5 md:px-20"
>
  <div class="max-w-4xl mx-auto">
    <h1
      class="text-primary text-4xl md:text-5xl font-bold mb-3 text-center animate-fadeInUp"
    >
      Preguntas <span class="text-secondary">frecuentes</span>
    </h1>
    <p
      class="text-gray-600 text-center mb-12 text-lg animate-fadeInUp"
      style="animation-delay: 0.1s"
    >
      Encontrá respuestas a las consultas más comunes
    </p>

    <div class="space-y-6" *ngFor="let thread of options; let i = index">
      <div
        class="bg-white rounded-2xl shadow-soft p-6 hover:shadow-medium transition-all duration-300 animate-fadeInUp"
        [style.animation-delay]="i * 0.1 + 's'"
      >
        <div class="flex items-center mb-4">
          <div class="w-2 h-8 bg-secondary rounded-full mr-4"></div>
          <h2 class="text-2xl font-bold text-primary">{{ thread.name }}</h2>
        </div>

        <div class="space-y-3">
          <div
            *ngFor="let item of options[i].faqs; let j = index"
            class="w-full"
          >
            <button
              (click)="item.open = !item.open"
              class="flex justify-between items-start text-left bg-gradient-to-r from-gray-50 to-gray-100 hover:from-primary/5 hover:to-secondary/5 transition-all duration-300 p-4 rounded-xl cursor-pointer w-full group border border-gray-200 hover:border-primary/30"
            >
              <span class="font-semibold text-primary flex-1 pr-4">{{
                item.question
              }}</span>
              <div
                class="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 group-hover:bg-primary group-hover:text-white transition-all duration-300 flex items-center justify-center"
              >
                <svg
                  *ngIf="!item.open"
                  class="w-5 h-5 transform group-hover:scale-110 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 4v16m8-8H4"
                  ></path>
                </svg>
                <svg
                  *ngIf="item.open"
                  class="w-5 h-5 transform group-hover:scale-110 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M20 12H4"
                  ></path>
                </svg>
              </div>
            </button>
            <div
              class="overflow-hidden transition-all duration-500 ease-in-out"
              [class.max-h-0]="!item.open"
              [class.max-h-96]="item.open"
            >
              <div
                class="p-4 text-gray-700 bg-white border-l-4 border-secondary rounded-b-xl mt-1 ml-2"
              >
                {{ item.answer }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
